import { render, staticRenderFns } from "./oring.vue?vue&type=template&id=9f1c65f8&scoped=true&"
import script from "./oring.vue?vue&type=script&lang=js&"
export * from "./oring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1c65f8",
  null
  
)

export default component.exports